import { useEffect, useMemo, useState, useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import Filter from "./FilterMarketingReport";
import Delete from "./Delete";
import Modal from "components/Common/Modal";
import { COLUMNS_DATA, FILTER_DEFINATIONS } from "./config";
import Table from "components/Common/Table/index";
import usePagination from "hooks/usePagination";
import useFilterHook from "hooks/useFilter";
import { MODALS, STALE_TIME } from "utils/constants";
import Loader from "components/Common/loader";
import { fetchMarketingPersonBusinessReport } from "services/marketingPersonBusinessReport";

const MarketingPersonBusinessReport = () => {
  const [isDelete, setIsDelete] = useState(-1);

  const [isSuperFranchise] = useState(() =>
    Number(localStorage.getItem("is_super_franchise")),
  );
  const [isFranchiseEmployee] = useState(() =>
    Number(localStorage.getItem("is_franchise_employee")),
  );
  const [isSubFranchise] = useState(() =>
    Number(localStorage.getItem("sub_franchise")),
  );

  const { updateCurrentPage, updateTotalRecords } = usePagination();

  const { filters, updateFilter, updateMultipleFilters } = useFilterHook(
    FILTER_DEFINATIONS,
    updateCurrentPage,
  );

  const deleteRow = useCallback((row) => {
    setIsDelete(row.cancellation_id);
  }, []);

  const {
    data: cancellationData,
    isLoading,
    refetch: refetchCancellations,
  } = useQuery(
    ["fetch-marketing-person-business-report", filters],
    () => fetchMarketingPersonBusinessReport(filters),
    {
      keepPreviousData: false,
      staleTime: STALE_TIME,
      onSuccess: (res) => {
        updateTotalRecords(res?.data?.additional_data?.total_count);
      },
      select: (res) => {
        const response = res?.data?.cancellation_data;
        if (response && response.length) {
          res.data.cancellation_data = response.map((x, index) => ({
            ...x,
            _index: index + 1,
          }));
        }
        return res;
      },
      onError: (res) => {
        console.error("Error fetching appointment cancellations:", res);
      },
    },
  );

  const edit1 = useCallback(
    (row) => {
      const params = new URLSearchParams({
        employee_code_id: row.employee_code_id,
        date_from: filters.date_from || "",
        date_to: filters.date_to || "",
        is_active: filters.is_active ?? true,
      });

      const url = `/marketing-person-business-report-detail?${params.toString()}`;

      window.open(url, "_blank");
    },
    [filters],
  );

  const getRowProps = useCallback(
    (row) => ({
      onClick: () => {
        edit1(row);
      },
    }),
    [edit1],
  );

  const onCloseDelete = useCallback(
    (refetch = false) => {
      if (refetch) refetchCancellations();
      setIsDelete(-1);
    },
    [refetchCancellations],
  );

  const columns = useMemo(() => {
    return COLUMNS_DATA({
      deleteRow,
      isSuperFranchise,
      isFranchiseEmployee,
      isSubFranchise,
      filters,
    });
  }, [
    deleteRow,
    isSuperFranchise,
    isFranchiseEmployee,
    isSubFranchise,
    filters,
  ]);

  useEffect(() => {
    if (filters.text) {
      refetchCancellations();
    }
  }, [filters.text, refetchCancellations]);

  if (isLoading) {
    return <Loader isLoading={isLoading} />;
  }

  return (
    <div className="container-fluid mb-3">
      <div className="box mb-4">
        <div className="boxHeader">
          <h1>Marketing Person Business Report</h1>
          <div className="ms-3">
            <Filter
              updateFilter={updateFilter}
              filters={filters}
              updateMultipleFilters={updateMultipleFilters}
            />
          </div>
        </div>
        <div className="left d-lg-flex mb-1 align-items-center"></div>

        <Modal
          show={isDelete !== -1}
          onHide={() => onCloseDelete()}
          modalName={MODALS.DELETE_CANCELLATION_MODAL}
          title={"Are you sure you want to delete this cancellation?"}
          footer={<Delete onClose={onCloseDelete} item={isDelete} />}
        />

        <div className="boxBody">
          <Table
            getRowProps={getRowProps}
            data={cancellationData?.data || []}
            isLoading={isLoading}
            tableColumns={columns}
            showPagination={false}
          />
        </div>
      </div>
    </div>
  );
};

export default MarketingPersonBusinessReport;
